import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import PortalAccountFullDetails from './portal-account-full-details.jsx';
export default class PortalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      showFullPortalAccountDetails: null,
      play: true
    };
  }
  toggleFullPortalAccountDetails() {
    this.setState({
      showFullPortalAccountDetails: !this.state.showFullPortalAccountDetails
    });

    var html = '<p><strong>Staff List - Change Email Address And Password</strong> </p>';

    if(this.props.data.customer_id === null || this.props.data.company_id === null){
      console.warn("User will do not have staff.")
      return;
    }
    $.ajax({
      url: "/api/v1/portal/portal-admin/get-user-staff-list",
      data: {
        api_token: window.api_token,
        company_id : this.props.data.company_id,
        customer_id : this.props.data.customer_id,
        user_id : this.props.data.id
      },
      cache: false,
      method: 'get',
    })
    .done(function(data) {
      if(data.data.length>0)
      {
        for(var i=0;i<data.data.length; i++)
        {
          html+='<div class="card userList"><div class="card-body"><p><input type="text" name="new_email[]" class="form-control staffListEmail" value="'+data.data[i].email+'" dataId="'+data.data[i].id+'"/></p><p><input type="text" class="form-control staffListPassword" name="new_password[]" placeholder="New Password Here" dataId="'+data.data[i].id+'"/></p></div></div>';
        }
        // html+='';
        $('.sectionStaffUsers').html(html);
        $('.portalAccountButton').removeClass('d-none');
      }
    });
  }
  triggerUpload(id) {
    $("#portal-admin-table-row-"+id+" .image-input").trigger('click');
  }
  handleFileConvert(id) {
    let userId = id;
    let uploadInput = document.getElementById(
      'image-input-'+userId
    );
    if (uploadInput && uploadInput.files && uploadInput.files[0]) {
      let fileReader = new FileReader();
      fileReader.addEventListener(
        "load",
        function(e) {
        document.getElementById(
          "image-"+userId
        ).src = e.target.result;
        document.getElementById(
          "b64-"+userId
        ).value = e.target.result;
        let newPortalAccountImageData = {
          api_token: window.api_token,
          image: e.target.result,
        };
        $.ajax({
          type: "POST",
          url: '/api/v1/portal/portal-admin/change-account-image/'+userId,
          data: newPortalAccountImageData,
          dataType: "text/json",
          complete: function(response) {
            let infoModal = $('#infomodal');
            if (response.status === 200) {
              $('#infomodallabel').html('Account Image changed successfully');
              $('#infomodal .modal-body').html(
                $.parseHTML(
                  response.responseText.replace(
                    /\"/g,
                    ""
                  )
                )
              );
              infoModal.modal();
              infoModal.on('hidden.bs.modal', function() {
                $('form input').val('').removeClass('active');
                $('form select').val('');
                $('form textarea').val('');
                $('form label').removeClass('active');
              });
              document.getElementById("image-" + userId).src = "/user-images/" + userId + "?timestamp=" + new Date().getTime();
            }
            else {
              $('#infomodallabel').html('Error changing Account Image');
              $('#infomodal .modal-body').html(
                $.parseHTML(
                  response.responseText.replace(
                    /\"/g,
                    ""
                  )
                )
              );
              infoModal.modal();
            }
          }
        });
      });
      fileReader.readAsDataURL(
        uploadInput.files[0]
      );
    }
  }
  render() {
    return(
      <div className="portal-admin-table-row-container">
        <Animate
          play={this.state.play}
          start={{opacity: 0}}
          end={{opacity: 1}}
          key={'portal-account-'+this.props.data.id+'-animate'}
        >
          <div
            className={
              "portal-admin-table-row portal-admin-table-row-summary " +
              (this.state.showFullPortalAccountDetails === true ? ' bold' : '')
            }
            id={
              "portal-admin-table-row-"+
              this.props.data.id
            }
          >
            <div className="cell column-type-user-id">
              <a
                href={
                  "/portal-admin/users/view/"+
                  this.props.data.id
                }
              >
                {this.props.data.id}
              </a>
            </div>
            <div className="cell column-type-company">
            {((this.props.data.company)&&(this.props.data.company.short_name))?this.props.data.company.short_name:''}
            </div>
            <div className="cell column-type-photo">
              <img
                id={"image-"+this.props.data.id}
                src={"/user-images/"+this.props.data.id + "?timestamp=" + new Date().getTime()} 
                onClick={() => { 
                  this.triggerUpload(this.props.data.id) 
                }}
              />
              <input
                type='file'
                onChange={() => {
                  this.handleFileConvert(this.props.data.id)}
                }
                className="form-control image-input"
                id={"image-input-"+this.props.data.id}
              />
              <input
                type="hidden"
                name="image-base-64"
                id={"b64-"+this.props.data.id}
              />
            </div>
            {((this.props.data.driver_id !== null && this.props.data.driver && this.props.data.is_subcontractor == 0) || (this.props.data.first_name) || (this.props.data.first_name)) ?
              <div className="cell column-type-name">
                {this.props.data.first_name} {this.props.data.last_name}
              </div>
            : <div className="cell column-type-name">
                {this.props.data.customer_name}
              </div>
            }
            <div className="cell column-type-email">
              {this.props.data.email}
            </div>
            <div className="cell column-type-account-created">
              {this.props.data.created_at}
            </div>
            <div className="cell column-type-account-last-logged-in">
              {this.props.data.updated_at}
            </div>
            <div
              className={
                "cell column-type-account-status-"+
                this.props.data.account_status
              }
            >
              {this.props.data.account_status}
            </div>
            <div className={
                "cell column-type-is-driver-archieved-"+this.props.data.is_driver_archieved
              }
            >
              {(this.props.data.customer_id != null && this.props.data.is_customer_archived) ? 'Yes'
                : (this.props.data.is_driver_archieved) ? 'Yes':'No' }
            
            </div>
            <div className="cell column-type-full-details">
              <button
                className="btn btn-dark btn-sm"
                onClick={() => {
                  this.toggleFullPortalAccountDetails()
                }}>
                full details <i className="fa fa-level-down"></i>
              </button>
            </div>
          </div>
          {(this.state.showFullPortalAccountDetails === true) ?
            <PortalAccountFullDetails
              key={
                'portal-account-'+
                this.props.data.id+
                '-full-details'
              }
              data={this.props.data}
            />
            :
            null
          }
        </Animate>
      </div>
    )
  }
}